import React, { useState, useEffect } from "react";
import {
  GetSubscriptionDetails,
  deleteUserSubscription,
} from "../services/PaymentService";
import { useAxiosInstance } from "../services/Interceptor";
import { ModalUpdateIntelliPay } from "./ModalUpdateIntelliPay";
import { useParams } from "react-router-dom";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { toast } from "react-toastify";
import { getAthleteUpcomingPayment } from "../services/AthleteService";

const CardDetails = ({ account, email }) => {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(false);
  const apiInstance = useAxiosInstance();
  const { userId } = useParams();
  const { user } = useAuthUser() || {};
  const [upcomingPayment, setUpcomingPayment] = useState();
  const HighSchoolCoach = user?.role?.toLowerCase?.() === "highschool";
  const accountRolePath =
    user?.role === "athlete"
      ? "athlete"
      : user?.role === "highschool"
        ? "highschool"
        : "university";

  useEffect(() => {
    if (HighSchoolCoach) return;
    const fetchDetails = async () => {
      try {
        const res = await GetSubscriptionDetails(apiInstance);
        setSubscription(res.data);
      } catch (err) {
        console.error("Error loading subscription details", err);
      }
    };
    fetchDetails();
  }, [apiInstance, HighSchoolCoach]);

  useEffect(() => {
    if (HighSchoolCoach) return;
    const fetchDetails = async () => {
      try {
        const upcoming = await getAthleteUpcomingPayment(apiInstance, user.id);
        setUpcomingPayment(upcoming);
      } catch (err) {
        console.error("Error loading subscription details", err);
      }
    };
    fetchDetails();
  }, [apiInstance, HighSchoolCoach, user.id]);

  const handleCancelSubscription = async () => {
    try {
      setLoading(true);
      await deleteUserSubscription(apiInstance);
      toast.success("Subscription cancelled successfully.");
      setSubscription(null);
      const redirectPath = `/${accountRolePath}/account`;

      window.location.href = redirectPath;
    } catch (err) {
      console.error("Error cancelling subscription", err);
      toast.error("Failed to cancel subscription.");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();

    return `${month}/${day}/${year}`;
  };

  const formatAmount = (amount) => {
    if (amount == null) return "";
    return `$${amount}`;
  };

  if (HighSchoolCoach || !subscription) return null;

  return (
    <div className="p-0">
      <h2 className="text-xl mb-4 uppercase">Card Information</h2>
      <div className="mt-4">
        <label>Card Number:</label>
        <input
          className="w-full p-2 border bg-gray-100 rounded"
          value={
            subscription.last4Digits
              ? "************" + subscription.last4Digits
              : ""
          }
          readOnly
        />
      </div>
      <div className="flex gap-4 mt-4">
        <div className="w-1/2">
          <label>Exp Month</label>
          <input
            className="w-full p-2 border bg-gray-100 rounded"
            value={subscription.expMonth}
            readOnly
          />
        </div>
        <div className="w-1/2">
          <label>Exp Year</label>
          <input
            className="w-full p-2 border bg-gray-100 rounded"
            value={subscription.expYear}
            readOnly
          />
        </div>
      </div>
      {upcomingPayment && (
        <div className="flex justify-between mt-6">
          {upcomingPayment.type === "FreeSubscription" ? (
            <label className="text-sm">
              {upcomingPayment.date
                ? `Your free subscription is active and will end on ${formatDate(
                    upcomingPayment.date,
                  )}.`
                : "Your subscription does not expire."}
            </label>
          ) : upcomingPayment.active ? (
            <label className="text-base">
              {`Your next monthly payment of ${formatAmount(
                upcomingPayment.amount,
              )} will be processed on ${formatDate(upcomingPayment.date)}.`}
            </label>
          ) : (
            <label className="text-sm">
              {`Your subscription will end on ${formatDate(
                upcomingPayment.date,
              )}. Update your credit card information to auto renew.`}
            </label>
          )}
        </div>
      )}
      <div className="flex justify-between mt-6">
        <button
          onClick={handleCancelSubscription}
          disabled={loading}
          className="bg-blue-600 text-white px-4 py-2 rounded-md uppercase hover:bg-blue-800 mt-4"
        >
          {loading ? "Cancelling..." : "Cancel Subscription"}
        </button>
        <a
          className="bg-red-500 text-white px-4 py-2 rounded-md uppercase hover:bg-red-700 mt-4 ml-3"
          href={`/${accountRolePath}/account/${account}`}
        >
          Update
        </a>
      </div>
      {userId !== undefined && <ModalUpdateIntelliPay />}
    </div>
  );
};

export default CardDetails;
